const API_URL = "/api";

export const REQUEST_WEATHER_DATA = "REQUEST_WEATHER_DATA";
export const RECEIVE_WEATHER_DATA = "RECEIVE_WEATHER_DATA";

const requestWeatherData = (channel, period) => ({
  type: REQUEST_WEATHER_DATA,
  data: { id: channel, period }
});

const receiveWeatherData = (channel, period, data) => ({
  type: RECEIVE_WEATHER_DATA,
  data: { weather: data, period, id: channel }
});

export const fetchWeatherData = (channel, period) => {
  return dispatch => {
    dispatch(requestWeatherData(channel, period));

    const url = API_URL + `/channel/${channel}/weather/${period}`;
    fetch(url)
      .then(response => response.json())
      .then(data => dispatch(receiveWeatherData(channel, period, data)));
  };
};

export const REQUEST_FORECAST_DATA = "REQUEST_FORECAST_DATA";
export const RECEIVE_FORECAST_DATA = "RECEIVE_FORECAST_DATA";

const requestForecastData = channel => ({
  type: REQUEST_FORECAST_DATA,
  data: { id: channel }
});

const receiveForecastData = (channel, data) => ({
  type: RECEIVE_FORECAST_DATA,
  data: { forecast: data.forecast, id: channel }
});

export const fetchForecastData = channel => {
  return dispatch => {
    dispatch(requestForecastData(channel));

    const url = API_URL + `/channel/${channel}/forecast`;
    fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data && Array.isArray(data.forecast))
          dispatch(receiveForecastData(channel, data));
        else dispatch(receiveForecastData(channel, []));
      });
  };
};
